module.exports = __webpack_public_path__ + "images/144eb21a8b1f7429754142ebbb7965a1.svg";